module.exports = __webpack_public_path__ + "static/img/weimaqi01.79ec212.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/hardProduct/images/weimaqi01.png
// module id = 8X+n
// module chunks = 1